export default __webpack_public_path__ + "static/media/top_person.61d17d1f.png";